export const SITE_NAME = 'Yakis Transporte Empresarial';

/**
 * Real site origin. Comes from the environment variable VITE_SITE_URL.
 * Falls back to the browser origin only when the env value is not available.
 */
export const SITE_URL = (
  import.meta.env.VITE_SITE_URL ||
  (typeof window !== 'undefined' ? window.location.origin : '')
).replace(/\/$/, '');

/** Existing absolute image already used by the site's social preview tags. */
export const DEFAULT_IMAGE =
  'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/498533ce623cf2fd2f552f0150c6fa4d.jpeg?ogv=13kiz3i';

/** Existing absolute logo asset. */
export const LOGO_IMAGE =
  'https://public.readdy.ai/ai/img_res/61a74797-87df-4251-bf99-e770eda51805.png';

export const toAbsoluteUrl = (path: string): string => {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_URL}${normalized}`;
};